<!-- @Author: wuhuiwang -->
<!-- @Date: 2023-6-25 20:27:30 -->
<!-- @Last Modified by: ruiwang -->
<!-- @Last Modified time: 2023-10-12 14:08:12 -->

<template>
    <div class="index">
        <div v-if="isHome">
            <warning-banner
                :class="{'warning-banner-hide': isBannerHidden}"
                :style="{height: headerTop}"
                @bannerClosed="handleBannerClosed"
            />
        </div>
        <nav-header
            :blog-list="blogList"
            :style="{top: isHome ? headerTop : '0'}"
        />
        <router-view
            :blog-list="blogList"
            class="view"
            :style="{marginTop: isHome && !isBannerHidden ? '1.4rem' : '0'}"
        />
        <ec-footer />
        <img
            v-if="isShowComplaint"
            class="pendant"
            src="./complaint/img/pendant.png"
            alt="Pelayanan Pengaduan"
            @click="$router.push({name: 'complaint'})"
        >
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';

import EcFooter from 'easycash/common/component/ec-footer.vue';
import getContactMixin from 'easycash/common/mixin/get-contact';
import prefetch from 'easycash/common/mixin/server-prefetch';
import Config from 'easycash/common/resource/blog';

import NavHeader from './component/nav-header.vue';
import WarningBanner from './component/warning-banner.vue';

export default {
    name: 'Index',

    components: {
        NavHeader,
        EcFooter,
        WarningBanner
    },

    head() {
        const {name: routeName, path} = this.$route;
        const getMeta = () => {
            const metaMap = {
                management: [{
                    property: 'description',
                    content: 'Tim Eksekutif Easycash'
                }],
                operation: [{
                    property: 'description',
                    content: 'Data Operasional Easycash'
                }],
                finacicalReport: [{
                    property: 'description',
                    content: 'Laporan Keuangan Easycash'
                }],
                publicationComplaint: [{
                    property: 'description',
                    content: 'Laporan Publikasi Easycash'
                }],
                faqGeneral: [{
                    property: 'description',
                    content: 'Pertanyaan Umum Easycash'
                }],
                faqLend: [{
                    property: 'description',
                    content: 'Pendanaan Easycash'
                }],
                faqBeware: [{
                    property: 'description',
                    content: 'Waspada Penipuan Easycash'
                }],
                faqLapsSjk: [{
                    property: 'description',
                    content: 'LAPS SJK Easycash'
                }],
                faqBorrow: [{
                    property: 'description',
                    content: 'Peminjaman Easycash'
                }],
                lend: [{
                    property: 'description',
                    content: 'Pendanaan Easycash'
                }],
                borrow: [{
                    property: 'description',
                    content: 'Pinjaman Easycash'
                }],
                home: [{
                    property: 'description',
                    content: 'Beranda Easycash'
                }],

            };

            return metaMap[routeName] || [{
                property: 'description',
                content: 'Pinjaman uang online cepat cair'
            }];
        };

        return {
            script: [{
                inner: `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KPB79CHG');
                `
            }],
            meta: getMeta(),
            link: [
                {
                    rel: 'canonical',
                    href: `https://easycash.id${path}`
                }
            ]
        };
    },

    mixins: [getContactMixin(['IDN_YQD', 'IDN_FIN']), prefetch('homeBlog')],

    provide() {
        const {blogList} = this;

        return {blogList};
    },

    data() {
        return {
            scrollTop: 0,
            isBannerHidden: false
        };
    },

    computed: {
        ...mapState('interestRate', ['status']),

        blogList() {
            return this.homeBlog?.body?.blogList || [];
        },

        isShowComplaint() {
            const complaintPage = ['home', 'borrow', 'faq'];

            return complaintPage.some(item => this.$route.name.indexOf(item) >= 0);
        },

        isHome() {
            return this.$route.name === 'home';
        },

        headerTop() {
            return this.isBannerHidden ? '0' : '1.4rem';
        }
    },

    beforeCreate() {
        if (!this.$ssrContext) return;
        this.$ssrContext.insertBeforeBody = '<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KPB79CHG" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>';
    },

    mounted() {
        window.onresize = () => {
            const deviceWidth = document.documentElement.clientWidth;
            const ratio = deviceWidth > 768 ? 144 : 37.5;
            const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            // eslint-disable-next-line no-bitwise
            const fz = deviceWidth <= 1440 ? ~~((width * 100000) / ratio) / 10000 : 100;
            document.getElementsByTagName('html')[0].style.cssText = `font-size: ${fz}px`;
            // eslint-disable-next-line no-bitwise
            const realfz =
                ~~(
                    +window.getComputedStyle(document.getElementsByTagName('html')[0]).fontSize.replace('px', '') *
                    10000
                ) / 10000;
            const ua = window && window.navigator && window.navigator.userAgent;
            if (fz !== realfz && !/samsung/.test(ua)) {
                document.getElementsByTagName('html')[0].style.cssText = `font-size: ${fz * (fz / realfz)}px`;
            }
        };

        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }

        const canGetApi = this.$app.getBusinessData('canGetApi');

        this.getConfig({canGetApi});
    },

    methods: {
        ...mapActions('interestRate', ['getConfig']),

        async initFetch() {
            const {
                data: {body}
            } = await Config.homeActive();

            return {body};
        },

        handleBannerClosed() {
            this.isBannerHidden = true;
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~bootstrap/scss/bootstrap-grid";

html {
    height: auto;
    overflow: auto;
}
</style>

<style lang="scss" rel="stylesheet/scss">
@font-face {
    font-family: "Mozaic HUM";
    font-weight: 300;
    src:
        url("~easycash/common/style/font-face/MozaicHUM-Light.woff2"),
        url("~easycash/common/style/font-face/MozaicHUM-Light.otf");
    font-display: swap;
}

@font-face {
    font-family: "Mozaic HUM";
    font-weight: 400;
    src:
        url("https://indoi18n-web-cdn.easycash.id/upload/admin/767fb388-41bd-44bd-9a11-8fccc889fb47.woff2"),
        url("~easycash/common/style/font-face/MozaicHUM-Regular.otf");
    font-display: swap;
}

@font-face {
    font-family: "Mozaic HUM";
    font-weight: 500;
    src:
        url("~easycash/common/style/font-face/MozaicHUM-Medium.woff2"),
        url("~easycash/common/style/font-face/MozaicHUM-Medium.otf");
    font-display: swap;
}

@font-face {
    font-family: "Mozaic HUM";
    font-weight: 700;
    src:
        url("~easycash/common/style/font-face/MozaicHUM-Bold.woff2"),
        url("~easycash/common/style/font-face/MozaicHUM-Bold.otf");
    font-display: swap;
}

@font-face {
    font-family: "Mozaic HUM";
    font-weight: 900;
    src:
        url("~easycash/common/style/font-face/MozaicHUM-Black.woff2"),
        url("~easycash/common/style/font-face/MozaicHUM-Black.otf");
    font-display: swap;
}

@font-face {
    font-family: "Quicksand";
    font-weight: 400;
    src:
        url("~easycash/common/style/font-face/Quicksand-Regular.woff2"),
        url("~easycash/common/style/font-face/Quicksand-Regular.ttf");
    font-display: swap;
}

@font-face {
    font-family: "Quicksand";
    font-weight: 700;
    src:
        url("~easycash/common/style/font-face/Quicksand-Bold.woff2"),
        url("~easycash/common/style/font-face/Quicksand-Bold.ttf");
    font-display: swap;
}

.index {
    box-sizing: border-box;
    letter-spacing: 0;
}

.pendant {
    position: fixed;
    right: 0.3rem;
    bottom: 0.3rem;
    width: 1.3rem;
    height: 1.3rem;
    z-index: 999;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }

    @media screen and (max-width: $screen-md) {
        width: 0.8rem;
        height: 0.8rem;
        right: 0.2rem;
        bottom: 0.2rem;
    }
}

.warning-banner {
    display: flex;
    align-items: center;
    width: 100%;
    top: 0;
    position: fixed;
    z-index: 999;
    background-image: linear-gradient(90deg, rgba(63, 63, 63, 1), rgba(45, 45, 45, 1));

    &-hide {
        display: none;
    }
}
</style>
